import { Controller } from "stimulus"
import Chart from "chart.js/auto"

const phaseColor = (ctx, phaseTransitionTime) => {
  if (ctx.p0.raw.x >= phaseTransitionTime) {
    return "#0030F0"
  } else {
    return "#00A8F0"
  }
}

const phaseBgColor = (ctx, phaseTransitionTime) => {
  const opacity = "0.2"
  if (ctx.p0.raw.x >= phaseTransitionTime) {
    return `rgba(0, 48, 240, ${opacity})`
  } else {
    return `rgba(0, 168, 240, ${opacity})`
  }
}

// The design dictates that the vertical phase transition line appears between the
// lighter and darker blue sections of the graph.
// To facilitate this, we need to add an interpolated value directly at the time of
// the phase transition.
const addInterpolatedPhaseChangeValue = (values, phaseTransitionTime) => {
  const index = values.findIndex((value) => value.x >= phaseTransitionTime)

  const p0 = values[index - 1]
  const p1 = values[index]

  if (!p0 || !p1) return values

  const interpolatedYValue =
    ((phaseTransitionTime - p0.x) / (p1.x - p0.x)) * (p1.y - p0.y) + p0.y

  const interpolatedValue = {
    y: interpolatedYValue,
    x: phaseTransitionTime,
  }

  return [...values.slice(0, index), interpolatedValue, ...values.slice(index)]
}

export default class extends Controller {
  static targets = ["chart", "data"]

  connect() {
    const data = JSON.parse(this.dataTarget.dataset.chartJson)
    const { values, phase_transition_time: phaseTransitionTime } = data
    const ctx = this.chartTarget.getContext("2d")

    console.log(phaseTransitionTime, data)

    const processedValues = addInterpolatedPhaseChangeValue(
      values,
      phaseTransitionTime,
    )

    const finalTemperature = processedValues[processedValues.length - 1].y

    new Chart(ctx, {
      type: "line",
      options: {
        plugins: {
          legend: {
            onClick: () => {},
            position: "bottom",
            labels: {
              boxHeight: 2,
              filter: function (item) {
                // Logic to remove a particular legend item goes here
                return !!item.text
              },
            },
          },
          annotation: {
            annotations: {
              phaseTransitionLine: {
                type: "line",
                scaleID: "xAxis",
                value: phaseTransitionTime,
                mode: "vertical",
                borderColor: "#000",
                borderWidth: 1,
                label: {
                  content: `${Math.round(phaseTransitionTime)}s`,
                  enabled: true,
                  position: "10%",
                },
              },
              finalTemperatureLine: {
                type: "line",
                scaleID: "yAxis",
                value: finalTemperature,
                mode: "horizontal",
                borderColor: "#FF3A3A",
                borderWidth: 2,
              },
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxis: {
            title: {
              display: true,
              text: "Temperature (°F)",
            },
          },
          xAxis: {
            type: "linear",
            title: {
              display: true,
              text: "Time (s)",
            },
          },
        },
      },
      data: {
        datasets: [
          {
            data: processedValues,
            pointHitRadius: 10,
            pointRadius: 0,
            fill: true,

            segment: {
              borderColor: (ctx) => phaseColor(ctx, phaseTransitionTime),
              pointBackgroundColor: (ctx) =>
                phaseColor(ctx, phaseTransitionTime),
              backgroundColor: (ctx) => phaseBgColor(ctx, phaseTransitionTime),
            },
          },

          // for legend only
          {
            label: "Phase 1",
            backgroundColor: "#00A8F0",
            borderColor: "#00A8F0",
            data: [],
          },
          {
            label: "Phase 2",
            backgroundColor: "#0030F0",
            borderColor: "#0030F0",
            data: [],
          },
          {
            label: "Final Temperature",
            backgroundColor: "#FF3A3A",
            borderColor: "#FF3A3A",
            data: [],
          },
        ],
      },
    })
  }
}
